<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">评委答疑</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 表格内容 -->
        <div class="content-container">
            <el-table :data="tableData" border style="width: 100%" class="judges-table">
                <el-table-column type="index" label="NO." width="80" align="center"></el-table-column>
                <el-table-column prop="sectionName" label="标段名称"></el-table-column>
                <el-table-column prop="userName" label="提交单位名称"></el-table-column>
                <el-table-column prop="question" label="问题标题"></el-table-column>
                <el-table-column prop="content" label="问题内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="提交时间" align="center"></el-table-column>
                <el-table-column prop="lastReplyTime" label="最晚回复时间" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.replyContent === '' || scope.row.replyContent === null"
                            class="status-unreplied">未回复</span>
                        <span v-else class="status-replied">已回复</span>
                    </template>
                </el-table-column>
                <el-table-column prop="replyContent" label="回复内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="replyTime" label="回复时间" align="center"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="handleReply(scope.$index)">回复</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 回复弹窗 -->
        <el-dialog title="回复澄清" :visible.sync="replyDialog.visible" width="600px" :append-to-body="true"
            :close-on-click-modal="false">
            <el-form :model="replyDialog.form" label-width="100px">
                <el-form-item label="回复内容">
                    <el-input type="textarea" v-model="replyDialog.form.reply" :rows="6" placeholder="请输入回复内容"
                        maxlength="500" show-word-limit>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="replyDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmitReply">回复</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getBidderFlowTitle } from '@/utils/projectInfo.js'
import { getClarifyList, replyClarify } from '@/api/evaluation/api'
export default {
    name: 'AnswerJudges',
    data() {
        return {
            sectionCode: this.$route.query.sectionCode || '',
            projectTitle: '',
            tableData: [],
            replyDialog: {
                visible: false,
                form: {
                    id: '',
                    reply: ''
                }
            }
        }
    },
    mounted() {
        this.getProjectInfo()
        this.loadData()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 加载数据
        loadData() {
            this.getClarifyList()
        },
        getClarifyList() {
            getClarifyList(this.sectionCode).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        // 打开回复弹窗
        handleReply(index) {
            const row = this.tableData[index]
            if (row.replyContent != null) {
                this.$message.error("已经回复过了")
                return;

            }

            this.replyDialog.form.id = row.id
            this.replyDialog.form.reply = ''
            this.replyDialog.visible = true
        },
        // 提交回复
        async handleSubmitReply() {
            if (!this.replyDialog.form.reply.trim()) {
                this.$message.warning('请输入回复内容')
                return
            }

            try {
                const res = await replyClarify({
                    id: this.replyDialog.form.id,
                    reply: this.replyDialog.form.reply
                })

                if (res.code === 200) {
                    this.$message.success('回复成功')
                    this.replyDialog.visible = false
                    // 刷新列表
                    this.getClarifyList()
                } else {
                    this.$message.error(res.msg || '回复失败')
                }
            } catch (error) {
                console.error('回复失败:', error)
                this.$message.error('回复失败，请重试')
            }
        }
    },
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-container {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
}

.judges-table {
    border-radius: 4px;
    overflow: hidden;

    /deep/ th {
        background: @gray-50 !important;
        color: @gray-700 !important;
        font-weight: 600;
        border-color: @gray-200 !important;
    }

    /deep/ td {
        color: @gray-600;
        border-color: @gray-200 !important;
    }
}

.status-unreplied {
    color: @error-color;
    font-weight: 500;
}

.status-replied {
    color: @success-color;
    font-weight: 500;
}

.view-btn {
    color: @gray-600;
    font-weight: 500;

    &:hover {
        color: @primary-color;
    }
}

// 回复弹窗样式
/deep/ .el-dialog {
    border-radius: 8px;
}

/deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
}

/deep/ .el-textarea__inner {
    border-color: @gray-300;
    color: @gray-700;

    &:focus {
        border-color: @primary-color;
        box-shadow: 0 0 0 2px fade(@primary-color, 15%);
    }
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .content-container {
        padding: 16px;
    }
}
</style>